import { render } from "./SystemPanel.vue?vue&type=template&id=6998e3fc&scoped=true&ts=true"
import script from "./SystemPanel.vue?vue&type=script&lang=ts"
export * from "./SystemPanel.vue?vue&type=script&lang=ts"

import "./SystemPanel.vue?vue&type=style&index=0&id=6998e3fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6998e3fc"]])

export default __exports__